import React from 'react';
import { Card as AntDCard, CardProps as AntDCardProps } from 'antd';

import Custom, { Props as CustomProps } from './Custom';
import classNames from 'classnames';
import './index.less';

interface Props extends Omit<AntDCardProps, 'size'> {
  variant?: 'primary' | 'secondary' | 'tertiary';
  illustration?: CustomProps['illustration'];
  size?: AntDCardProps['size'] | 'large';
  withBorder?: boolean;
  withShadow?: boolean;
}

export type { Props as CardProps };

export default function Card({
  illustration,
  withBorder = false,
  withShadow = false,
  className = '',
  variant = 'secondary',
  size = 'default',
  ...props
}: Props) {
  if (variant === 'secondary') {
    return (
      <AntDCard
        size={size === 'large' ? 'default' : 'small'}
        className={classNames(className, {
          'with-border': withBorder,
          'with-shadow': withShadow,
        })}
        {...props}
      />
    );
  }

  return (
    <Custom
      size={size === 'large' ? 'default' : 'small'}
      variant={variant}
      illustration={illustration}
      className={className}
      {...props}
    />
  );
}
